<template>
    <div class="publish-widget">
        <v-expansion-panel class="d-block" :value="0">

            <div class="card-curvey">
                <v-expansion-panel-content>
                        <template v-slot:header>
                                Logo / Avatar
                        </template>

                        <div class="publish-input-body">
                            <image-input  :small="true" :url="widgetParameters.logo" @onImageUpload="widgetParameters.logo = $event "></image-input>
                        </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Headlines
                    </template>

                    <div class="publish-input-body">
                        <label>Header</label>
                        <v-text-field
                                class="mt-2"
                                v-model="widgetParameters.header"
                                outline
                        ></v-text-field>
                        <label>Sub Header</label>
                        <v-text-field
                                class="mt-2"
                                v-model="widgetParameters.subHeader"
                                outline
                        ></v-text-field>
                    </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Colors
                    </template>

                    <div class="publish-input-body">
                        <v-layout row wrap>
                            <v-flex xs4>
                                <span> Header Background</span>
                                <swatches show-fallback class="inline-block" colors="text-advanced" v-model="widgetParameters.colors.header" />
                            </v-flex>
                            <v-flex xs4>
                                <span> Header Font</span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.headerFont" />
                            </v-flex>
                            <v-flex xs4>
                                <span> User Answer Background</span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.userSide" />
                            </v-flex>
                            <v-flex xs4>
                                <span> User Answer Font</span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.userSideFont" />
                            </v-flex>
                            <v-flex xs4>
                                <span>Bot Answer background </span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.chatBotAnswer" />
                            </v-flex>
                            <v-flex xs4>
                                <span> Bot Answer Font</span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.chatBotAnswerFont" />
                            </v-flex>
                            <v-flex xs4>
                                <span> Bubble button</span>
                                <swatches show-fallback colors="text-advanced" v-model="widgetParameters.colors.bubbleButton" />
                            </v-flex>
                        </v-layout>
                    </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Chat Bubbles
                    </template>

                    <div class="publish-input-body">
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button
                                    v-for="btn in chatBubbleOptions"
                                    :class="btn.class"
                                    @click="changeChatBubble(btn.value)"
                            >
                                {{btn.name}}
                            </button>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Font
                    </template>

                    <div class="publish-input-body">
                        <label>Font Family</label>
                        <v-autocomplete
                            class="mt-2"
                            :items="googleFonts"
                            item-value="family"
                            item-text="family"
                            v-model="widgetParameters.font"
                            solo
                            outline
                        ></v-autocomplete>
                        <label>Font Size</label>
                        <v-text-field
                            v-model="widgetParameters.fontSize"
                            type="number"
                            outline
                        ></v-text-field>
                    </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Backgrounds / Images
                    </template>

                    <div class="publish-input-body">
                        <v-layout row wrap>
                            <v-flex xs6>
                                <h5 class="mb-3 d-block">Open Chat Icon</h5>
                                <image-input  :small="true" :url="widgetParameters.openBubbleImage" @onImageUpload="widgetParameters.openBubbleImage = $event "></image-input>
                            </v-flex>
                            <v-flex xs6>
                                <h5 class="mb-3 d-block">Chat Background</h5>
                                <image-input  :validation="false" :small="true" :url="widgetParameters.chatBackgroundImage" @onImageUpload="widgetParameters.chatBackgroundImage = $event "></image-input>
                            </v-flex>
                        </v-layout>

                    </div>
                </v-expansion-panel-content>
            </div>

            <div class="card-curvey">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        Size / Position
                    </template>

                    <div class="publish-input-body">
                        <v-layout row wrap>
                            <v-flex xs6>
                                    <label>Width</label>
                                <v-text-field
                                        class="mt-2"
                                        v-model="widgetParameters.widgetWidth"
                                        type="number" min="400" max="800"
                                        outline
                                         >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <label>Height</label>
                                <v-text-field
                                        class="mt-2"
                                        v-model="widgetParameters.widgetHeight"
                                        type="number" min="400" max="800"
                                        outline
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <label class="d-block mb-2">Position</label>
                                <v-btn-toggle v-model="widgetParameters.direction">
                                    <v-btn large round class="rounded-right-btn" value="ltr">
                                        LTR
                                    </v-btn>
                                    <v-btn large round class="rounded-left-btn"  value="rtl">
                                        RTL
                                    </v-btn>
                                </v-btn-toggle>
                            </v-flex>
                        </v-layout>

                    </div>
                </v-expansion-panel-content>
            </div>

        </v-expansion-panel>

        <div class="text-right">
            <a @click="publishWidget"  href="#generated_widget_card" class="v-btn  v-btn v-btn--large v-btn--round  theme--light primary">Publish And Generate Widget</a>
        </div>
        <div v-if="generated_widget_card" id="generated_widget_card" class="card-curvey generated-widget p-3">
           <p>{{ generatedWidget }}</p>
        </div>
    </div>
</template>

<script>
    import vueDropzone from 'vue2-dropzone'
    import Swatches from 'vue-swatches'
    import common from "../../utils/common";
    import imageInput from '../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone'
    export default {
        name: "designForm",
        components: {
            vueDropzone,
            Swatches,
            imageInput
        },
        data () {
            return {
                chatBubbleOptions: [
                    {
                        name: 'Solid',
                        value: 'solid',
                        class: 'btn btn-solid'
                    },
                    {
                        name: 'Rounded',
                        value: 'rounded',
                        class: 'btn btn-rounded active'
                    },
                    {
                        name: 'Curvey',
                        value: 'curvey',
                        class: 'btn btn-curvey'
                    }
                ],
                generated_widget_card: false,
                googleFonts: [],
                generatedWidget: '',
                settings: {},
                widgetParameters: {
                    logo:"https://testing-api.botter.live/uploads/2019-06-16/1560683507.png",
                    header:"Welcome",
                    subHeader:"Please leave a message and we will contact you soon",
                    colors: {
                        userSide:"#007FE8",
                        userSideFont: "white",
                        header:"#007FE8",
                        headerFont:"white",
                        chatBotAnswer:"#eee",
                        chatBotAnswerFont:"#333",
                        bubbleButton: "#007FE8"
                    },
                    widgetWidth: 600,
                    widgetHeight: 400,
                    openBubbleImage:"https://testing-api.botter.live/uploads/2019-06-16/1560683507.png",
                    font:"Cairo",
                    fontSize: 14,
                    chatBubble:"rounded",
                    chatBackgroundImage:"",
                    direction: 'ltr'
                }
            }
        },
        mounted() {
            this.$emit('updatePreview', this.widgetParameters)
            // this.loadDefaultImages()
            this.getGoogleFonts()
            this.getSettings()
        },
        methods: {
            loadDefaultImages() {
                let imageUrl = 'https://vuejs.org/images/logo.png'
                let imageName = imageUrl.split('/')
                imageName = imageName[(imageName.length - 1)]
                let imageType = imageName.split('.')
                imageType = `image/${imageType[1]}`
                this.$refs.logo.manuallyAddFile({ size: 1024, name: imageName, type: imageType }, imageUrl)
                this.$refs.openBubbleImage.manuallyAddFile({ size: 1024, name: imageName, type: imageType }, imageUrl)
            },
            changeChatBubble(value) {
                this.widgetParameters.chatBubble = value
                for (let i=0; i< this.chatBubbleOptions.length; i++) {
                    if (this.chatBubbleOptions[i].value === value) {
                        this.chatBubbleOptions[i].class = `btn btn-${value} active`
                    } else {
                        this.chatBubbleOptions[i].class = `btn btn-${this.chatBubbleOptions[i].value}`
                    }
                }
            },
            getGoogleFonts(){
                this.$http_without_base.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBr6nsPTXn2O1RTMMt4OTaY9ofFh6QEgWs')
                    .then(response=>{
                        this.googleFonts = response.data.items
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            logoMaxfilesexceeded(file){
                this.$refs.logo.removeAllFiles();
                this.$refs.logo.addFile(file);
            },
            addFile(ref) {
                const userData = this.$store.getters.userData
                let images = this.$refs[ref].getAcceptedFiles()
                const fd = new FormData();
                fd.append("file", images[0], "filename" + Date.now());
                this.$http_multipart
                    .post("files", fd)
                    .then(response=>{
                        this.widgetParameters[ref] = response.body.url
                    },
                    function (error) {
                        console.log(error)
                    }
                    )
            },
            changeDirection (direction) {
              this.widgetParameters.direction = direction
            },
            getSettings() {
                this.$http_bot.get('/settings/')
                    .then(response=>{
                        this.settings = response.data
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
            publishWidget(){
                let widgetParameters = JSON.stringify(this.widgetParameters)
                let widgetJsFile = '<script src="https://widgets.botter.live/widget.js"></scr'+'ipt>'
                this.generatedWidget = `
                    <div id="botter-widget"
                        widget_parameters='${widgetParameters}'
                        directline="${this.settings.direct_line}"
                        bing-subscription-key="ca86942144d34294a7dfd3afddd8dd50"
                        locale="" >
                    </div>
                    ${widgetJsFile}
                `
                this.generated_widget_card = true
                setTimeout(function(){
                    document.getElementById('generated_widget_card').scrollIntoView()
                    }, 1000);
            },
        },
        watch: {
            widgetParameters: {
                handler(state){
                    this.$emit('updatePreview', state)
                },
                deep: true
            }

        }
    }
</script>

<style scoped>
    .publish-input-body {
        padding: 20px 0;
    }

    .card-header {
        padding: 0;
    }
    .card-header h5 {
        padding: 1rem 1.25rem;;
        font-size: 1.2em;
        cursor: pointer;
    }
    .btn-group .btn {
        margin-right: 20px;
        color: white;
        position: relative;
        padding: 12px 30px;
        font-size: .75rem;
        font-weight: 400;
        line-height: 1.42857;
        text-decoration: none;
        text-transform: uppercase;
        letter-spacing: 0;
        cursor: pointer;
        background: #919191;
        border: 0;
        border-radius: 0.2rem;
        outline: 0;
        transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        will-change: box-shadow, transform;
    }
    .btn-group .active {
        background: #007FE8;
    }
    .btn-solid {
        border-radius: 0;
    }
    .btn-rounded {
        border-radius: 20px 0 20px 20px !important;
    }
    .btn-curvey{
        border-radius: 5px 0 5px 5px !important;
    }
    .btn-publish {
        width: 100%;
        font-size: 20px;
    }
    .generated-widget {
        text-transform: initial;
    }
    .generated-widget p {
        word-break: break-all;
    }


</style>

<style>

    @import url('~vue-swatches/dist/vue-swatches.min.css');
    .vue-swatches__trigger {
        width: 75% !important;
        border: 1px solid #eee;
    }
    .active-switch-inline {
        padding-top: 8px !important;
    }

    .dimmer.dialog {

    }
    .vue-swatches__container:not(.vue-swatches--inline) {
        max-height: 350px !important;
    }
</style>
